import { 
    ACTUALIZAR_LIST_CONTROL,
    AGREGAR_CONTROL,
  } from "./controlActions";

  const controlReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_CONTROL: {
            return {
                ...state,
                controlList: action.payload
            }
        };

        case AGREGAR_CONTROL:{
            return {
                 ...state,
                 controlList: [action.payload, ...state.controlList]
             }
         };

        default:
            return state;

    }
  }

  export default controlReducer;